<script context="module">
  // Живёт ВНЕ компонента (перенос LoadingOverlay.tsx): экран переключает ветки
  // (спавн → игра) и компонент пересоздаётся. Без метки марка «J» переигрывала
  // появление при каждом ремоунте — на спавне лого «загружалось» дважды.
  let shownAt = 0;
</script>

<script>
  // Перенос src_ui/web/src/screens/LoadingOverlay.tsx — дословно.
  // Чёрный фон, золотая «J» с появлением inPop + дыханием, три точки.
  // Появляется МГНОВЕННО (накрывает кадр сразу), гаснет плавно за ~1с.
  import { onDestroy } from 'svelte';

  export let show = false;

  // runId растёт при каждом НАСТОЯЩЕМ показе → ремоунт «J» и анимация заново
  let runId = 0;
  let prev = false;
  // ремоунт при уже идущем показе (переключение ветки экрана) — продолжаем
  // без повторного появления
  const cont = show && Date.now() - shownAt < 2500;

  $: {
    if (show && !prev && !cont) runId += 1;
    prev = show;
  }

  let keepTimer = null;
  $: {
    if (show) {
      shownAt = Date.now();
      if (!keepTimer) keepTimer = setInterval(() => { shownAt = Date.now(); }, 400);
    } else if (keepTimer) {
      clearInterval(keepTimer); keepTimer = null;
    }
  }
  onDestroy(() => { if (keepTimer) clearInterval(keepTimer); });
</script>

<div
  style="position:fixed;inset:0;z-index:100;background:#000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:clamp(30px,6vh,58px);opacity:{show ? 1 : 0};pointer-events:{show ? 'auto' : 'none'};transition:{show ? 'none' : 'opacity 1s ease'}"
>
  <!-- контент всегда смонтирован (виден и во время затухания); key=runId переигрывает inPop -->
  {#key runId}
    <!-- фирменная марка — та же векторная «J», что в худе и на загрузке мода -->
    <svg
      viewBox="0 0 36 22" role="img" aria-label="JUST RP"
      style="width:min(42vw,46vh,520px);height:auto;display:block;animation:{cont
        ? 'lo_breathe 2s ease-in-out 0s infinite'
        : 'lo_inPop 1.4s cubic-bezier(.16,.8,.18,1) both, lo_breathe 2s ease-in-out 1.4s infinite'}"
    >
      <defs>
        <linearGradient id="lo_g" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stop-color="#c8852f" /><stop offset="45%" stop-color="#f0c863" /><stop offset="100%" stop-color="#ffe896" />
        </linearGradient>
      </defs>
      <path fill="url(#lo_g)" d="M35.4.6 18.9 14.1c-1.6 4.8-5.1 7.2-10.4 7.2-3.5 0-6.3-1.3-8.1-3.8l4.7-3.6c1.1 1.4 2.4 2.1 3.9 2.1 1.8 0 3.1-1 4-3l4.5-9.7 17.9-2.7z" />
    </svg>
    <div style="display:flex;gap:clamp(10px,1.4vw,15px);opacity:{cont ? 1 : 0};animation:{cont ? 'none' : 'lo_inUp .8s ease 1.4s forwards'}">
      {#each [0, 1, 2] as i (i)}
        <span style="width:clamp(11px,1.1vw,15px);height:clamp(11px,1.1vw,15px);border-radius:50%;background:#ffd11f;box-shadow:0 0 13px rgba(255,205,30,.6);animation:lo_dot 2s ease-in-out 1.4s infinite"></span>
      {/each}
    </div>
  {/key}
</div>
